import React, { Component } from 'react';
import { connect } from 'react-redux';
import Article from 'grommet/components/Article';
import Tabs from 'grommet/components/Tabs';
import Box from 'grommet/components/Box';
import Tab from 'grommet/components/Tab';
import Accordion from './Accordion';
import { fetchDefaults, defaultfetchServerList } from '../Redux/actions/epaActions';
//import { connect } from 'react-redux';
import { toggleSizeButton } from '../../State/actions/sessions';
import Layer from 'grommet/components/Layer';
import Spinning from 'grommet/components/icons/Spinning';
import { getextranodesqty } from '../Redux/actions/epaActions';
import {updateServiceLicenses} from '../commonLogic.js';
import Heading from 'grommet/components/Heading';
import * as Constants from '../Redux/action_types/EPAConstants';

var serverList = {
    storage: ['Apollo 4200 28 LFF', 'Apollo 4510 60 LFF', 'DL380 Gen10 19 LFF'],
    databases: ['Apollo 2000', 'DL360 Gen10', 'Synergy'],
    streaming: ['Apollo 2000', 'DL360 Gen10', 'Synergy'],
    analytics: ['Apollo 2000', 'DL360 Gen10', 'Synergy'],
    ai: ['Apollo 2000', 'DL360 Gen10', 'Synergy'],
    iot: ['Apollo 2000', 'DL360 Gen10', 'Synergy']
}
var country = '';
class Functions extends Component {
    constructor() {
        super();
        this.state = { activeIndex: 0 }
        this.getActive = this.getActive.bind(this);
    }

    getActive() {
        var expandHiveService = false;
        var expandCassandraService = false;
        var expandImpalaService = false;
        var expandHBaseService = false

        this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
            switch (val['@Type']) {
                case "Database":
                    if (Array.isArray(val.Service)) {
                        val.Service.filter((service, id) => {
                            if (id === 0) {
                                if (service['@Selected'] === "true") {
                                    expandHiveService = true
                                }
                            }
                            if (id === 1) {
                                if (service['@Selected'] === "true" ) {
                                    expandCassandraService = true

                                }
                            }
                            if (id === 2) {
                                if (service['@Selected'] === "true") {
                                    expandImpalaService = true

                                }
                            }
                            if (id === 3) {
                                if (service['@Selected'] === "true") {
                                    expandHBaseService = true

                                }
                            }
                        })
                    }
                    break;
            }
        })
           
        if (this.state.activeIndex === 1) {
            return <Box margin='small' pad={{ between: 'small' }}>
                <Accordion title='Hive' expanded={expandHiveService} isDefault={true} type='Database' servers={serverList.databases} />
                <Accordion title='Cassandra' expanded={expandCassandraService} isDefault={false} type='Database' servers={serverList.databases} />
                <Accordion title='Impala' expanded={expandImpalaService} isDefault={false} type='Database' servers={serverList.databases} />
                <Accordion title='HBase' expanded={expandHBaseService} isDefault={false} type='Database' servers={serverList.databases} />
            </Box>
        }
        else return '';
    }
    componentWillUnmount() {     
        if (this.props.defaultSizerWorkload !== undefined && this.props.defaultSizerWorkload !== null) {
            if (this.props.defaultSizerWorkload.getExtraNodes) {
                var value = {
                    "input": {
                        "Workload": null,
                    }
                }
                value.input.Workload = this.props.workload;
                this.props.GetExtraNodesQty(value)
            }
        }
    }
    componentWillMount() {
        this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
        if (val['@Type'] === "Storage") {
             val.Service.filter((service) => {
             if (service['@Type'] === Constants.HDFS_EC || service['@Type'] === Constants.HDFS_) {
                    service['@Type'] = Constants.DATA_LAKE;
             }})
        }})
        if(this.props.workload.UserInputs.Environments.HadoopServices !== undefined) {
            if(this.props.workload.UserInputs.Environments.HadoopServices.Deployment === undefined) {
                this.props.workload.UserInputs.Environments.HadoopServices.Deployment = 'false';
            }
            if(this.props.workload.UserInputs.Environments.HadoopServices.AppStore === undefined) {
                this.props.workload.UserInputs.Environments.HadoopServices.AppStore = 'false';
            }
            if(this.props.workload.UserInputs.Environments.HadoopServices.Installation === undefined) {
                this.props.workload.UserInputs.Environments.HadoopServices.Installation = 'false';
            }
            if(this.props.workload.UserInputs.Environments.HadoopServices.SingleImage === undefined) {
                this.props.workload.UserInputs.Environments.HadoopServices.SingleImage = {
                    "@Qty" : "1",
                    "#text" : "false"
                }
            }
            if(this.props.workload.UserInputs.Environments.HadoopServices.CustomImage === undefined) {
                this.props.workload.UserInputs.Environments.HadoopServices.CustomImage = {
                    "@Qty" : "1",
                    "#text" : "false"
                }
            }
        }
        this.props.workload.UserInputs.Environments.Functions.Function.map(Function => {
            if (Array.isArray(Function.Service)) {
                Function.Service.map(service => {
                    if(service["@mixedStorage"] === undefined) {
                        service["@mixedStorage"] = "False"
                    }
                    if(service.Hardware["@dataDriveType"] === undefined) {
                        service.Hardware["@dataDriveType"] = ""
                    }
                    if (service.DataDisks === undefined) {
                        let DataDiskArray = [
                            {
                                Item: {
                                    '@disk': service.Hardware['@DataDisk'],
                                    '@qty': service.Hardware['@DiskQty'],
                                    "@volumeName": "Data_0"
                                }
                            }
                        ]
                        service.DataDisks = DataDiskArray
                    }
                        if (!(Array.isArray(service.DataDisks))) {
                            let DataDiskArray = [
                                {
                                    Item: {
                                        '@disk': service.DataDisks.Item["@disk"],
                                        '@qty': service.DataDisks.Item["@qty"],
                                        "@volumeName": "Data_0"
                                    }
                                }
                            ]
                            service.DataDisks = DataDiskArray
                        }
                })  
            } else {
                if(Function.Service["@mixedStorage"] === undefined) {
                    Function.Service["@mixedStorage"] = "False"
                }
                if(Function.Service.Hardware["@dataDriveType"] === undefined) {
                    Function.Service.Hardware["@dataDriveType"] = ""
                }
                if(Function.Service.DataDisks === undefined) {
                    let DataDiskArray = [
                    {
                        Item : {
                        '@disk' : Function.Service.Hardware['@DataDisk'],
                        '@qty' : Function.Service.Hardware['@DiskQty'],
                        "@volumeName": "Data_0"
                        }
                    }
                    ]
                    Function.Service.DataDisks = DataDiskArray
                }
                    if (!(Array.isArray(Function.Service.DataDisks))) {
                        let DataDiskArray = [
                            {
                                Item: {
                                    '@disk': Function.Service.DataDisks.Item["@disk"],
                                    '@qty': Function.Service.DataDisks.Item["@qty"],
                                    "@volumeName": "Data_0"
                                }
                            }
                        ]
                        Function.Service.DataDisks = DataDiskArray
                    }
            }
        })
        
    }

    componentDidMount() {

        this.props.workload.ServicesInput===undefined && this.props.sessionsDefaults.inputs!==""? 
        this.props.onUpdateDefaultSession(this.props.sessionsDefaults.inputs):'';
      
        if (this.props.activeSession.isSizeEnabled)
            this.props.OnToggleSizeButton(false);
        var index = this.props.defaultSizerWorkload.Indexes.functions;
        this.setState({ activeIndex: index })
        var value = {
        "input": {
          "Workload": null,
        }
      }
        var Iputs = {
            DefaultData: [
                {
                   
                    "function": Constants.STORAGE_,
                    "service": Constants.DATA_LAKE,
                    "workload":value
                },
                {
                  
                    "function": "Storage",
                    "service": "Scality",
                    "workload":value
                },
                {
                   
                    "function": "Storage",
                    "service": "Weka",
                    "workload":value
                },
                {
                    
                    "function": "Database",
                    "service": "Hive",
                    "workload":value
                },
                {
                    
                    "function": "Database",
                    "service": "Cassandra",
                    "workload":value
                },
                {
                   
                    "function": "Database",
                    "service": "Impala",
                    "workload":value
                },
                {
                    
                    "function": "Database",
                    "service": "HBase",
                    "workload":value
                },
                {
                   
                    "function": "Streaming",
                    "service": "Spark Streaming",
                    "workload":value
                },
                {
                  
                    "function": "Streaming",
                    "service": "Kafka",
                    "workload":value
                },
                {
                    
                    "function": "Streaming",
                    "service": "Flink",
                    "workload":value
                },
                {
                    "function": "Streaming",
                    "service": "Storm",
                    "workload":value
                },
                {
                   
                    "function": "Analytics",
                    "service": "Yarn",
                    "workload":value
                },
                {
                    
                    "function": "Analytics",
                    "service": "Spark",
                    "workload":value
                },
                {
                   
                    "function": "AI",
                    "service": "Tensorflow",
                    "workload":value
                },
                {
                   
                    "function": "AI",
                    "service": "PyTorch",
                    "workload":value
                },
                {
                    
                    "function": "IoT",
                    "service": "MiNifi",
                    "workload":value
                },
                {
                    "PricingRegion": this.props.workload.UserInputs.Country
                }

            ]
        }

        if (this.props.defaultSizerWorkload.serversList.length == 0) {
            if(this.props.iterationvalue === 1)
            {
                if(this.props.workload.UserInputs.Country !== country){
                    country = this.props.workload.UserInputs.Country;
                }
                this.props.OnDefaultFetchServerList(Iputs);
                this.props.OnIterationCountIncrease(2) 
            }
           
        }
        if(this.props.workload.UserInputs.Country !== country){
            country = this.props.workload.UserInputs.Country;
            this.props.OnDefaultFetchServerList(Iputs);
        }
        
        if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses !== undefined && this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric === undefined) {
            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric = {
                '@IsSelected': 'false',
                License: [
                    {
                        '@Type': Constants.DATAFABRIC_XD,
                        '@IsSelected': Constants.fALSE_,
                        '@Description': Constants.NONE_,
                    },
                    {
                        '@Type': Constants.DATAFABRIC_ANALYTICS,
                        '@IsSelected': Constants.fALSE_,
                        '@Description': Constants.NONE_,
                    },
                    {
                        '@Type': Constants.DATAFABRIC_SPARK,
                        '@IsSelected': Constants.fALSE_,
                        '@Description': Constants.NONE_,
                    },
                    {
                        '@Type': Constants.DATAFABRIC_STREAMS,
                        '@IsSelected': Constants.fALSE_,
                        '@Description': Constants.NONE_
                    },
                    {
                        '@Type': Constants.DATAFABRIC_DATABASE,
                        '@IsSelected': Constants.fALSE_,
                        '@Description': Constants.NONE_,
                    },
                    {
                        '@Type': Constants.DATAFABRIC_BUNDLE,
                        '@IsSelected': Constants.fALSE_,
                        '@Description': Constants.NONE_,
                    }
                ]
            }
        }
        if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses) {
            if (!this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric.License.find(license => license["@Type"] === Constants.DATAFABRIC_SERVICES)) {
                let dataFabricService = {
                    "@Type": Constants.DATAFABRIC_SERVICES,
                    "@IsSelected": Constants.fALSE_
                }
                this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric.License.push(dataFabricService);
            }
        }
        if (!Array.isArray(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License) || this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.length === 2 || this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License === undefined) {
            // BluedataMLsftwreValue=this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License[1]['@Description']

            let License = [
                {
                    "@Description": 'None',
                    "@IsSelected": "true",
                    "@Type": "BlueData"
                },
                {
                    "@Description": "None",
                    "@IsSelected": "false",
                    "@Type": "BlueDataAI"
                },
                {
                    "@Description": "24x7 1y",
                    "@IsSelected": "true",
                    "@Type": "HPE Container Platform"
                },
                {
                    "@Description": "None",
                    "@IsSelected": "false",
                    "@Type": "Data Apps"
                },
                {
                    "@Description": "None",
                    "@IsSelected": "false",
                    "@Type": "Data Apps Universal"
                },
                {
                    "@Description": "None",
                    "@IsSelected": "false",
                    "@Type": "Data Apps w/ML Ops"
                },
                {
                    "@Description": "None",
                    "@IsSelected": "false",
                    "@Type": "Data Apps Universal w/ML Ops"
                },
            ]

            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License = License
        }
        if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses) {
            if (Array.isArray(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License)) {
                if (!this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(license => license["@Type"] === Constants.HPE_EZMERAL_DF_XD)) {
                    let dataFabricLicense = {
                        "@Description" : Constants.NONE_,
                        "@IsSelected": Constants.fALSE_,
                        "@Type" : Constants.HPE_EZMERAL_DF_XD
                    }
                    this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.push(dataFabricLicense);
                }
            }
            if (this.props.sessionsDefaults.inputs) {
                updateServiceLicenses(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses, this.props.sessionsDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License);
            }
        }
        if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Configuration === undefined) {
            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Configuration = {
                '@Type' : 'EPIC',
            }
        }
        if(this.props.country !== undefined){
            this.props.workload.UserInputs.Country =  this.props.country  // Selected country is not updated in the workload. - By Aditya
            }

        if (!this.props.workload.UserInputs.Environments.Growth) {
            this.props.workload.UserInputs.Environments.Growth = Constants.DEFAULT_GROWTH_OBJECT;
        }
    }
   
    render() {
        var LoadindData = ""
        var expandHDFSService = false
        var expandScalityService = false
        var expandWekaService = false
        var expandSparkService = false
        var expandKafkaService = false
        var expandFlinkService = false
        var expandStormService = false
        var expandYarnService = false
        var expandAnalyticsSparkService = false
        var expandTensorflowService = false
        var expandPyTorchService = false
        var expandMiNifiService = false
        if (this.props.isLoading) {
            if (this.props.isLoading) {
                LoadindData = <Layer style={{ zIndex: '500 !important' }}>
                    <Box direction='row' style={{ padding: '40px', backgroundColor: "#425563" }} size='medium' pad={{ 'between': 'small' }}>
                        <Spinning size='small' style={{ color: "#fff" }} />
                        <Heading tag='h5' margin='none' style={{ color: "#fff" }}>Please wait while fetching the data.</Heading>
                    </Box>
                </Layer>
            }
        }
        // if(this.props.SelectedService===undefined)
        // {
        //     let value={
        //         "value":"Tabchanged"
        //     }
        //      this.props.SelectedServericeValue(value)
        // }
       
        this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
            switch (val['@Type']) {
                case "Storage":
                    if (Array.isArray(val.Service)) {
                        val.Service.filter((service, id) => {
                            if (id === 0) {
                                if (service['@Selected'] === "true" ) {
                                    expandHDFSService = true
                                }
                            }
                            if (id === 1) {
                                if (service['@Selected'] === "true" ) {
                                    expandScalityService = true
                                }
                            }
                            if (id === 2) {
                                if (service['@Selected'] === "true") {
                                    expandWekaService = true
                                }
                            }
                        })
                    }
                    break;
                case "Streaming":
                    if (Array.isArray(val.Service)) {
                        val.Service.filter((service, id) => {
                            if(service['@Type']==="Flume" ) 
                            {
                                service['@Type']="Flink"
                            }else if(service['@Type']==="Nifi")
                            {
                                 service['@Type']="Storm"
                            }

                            if (id === 0) {
                                if (service['@Selected'] === "true") {
                                    expandSparkService = true
                                }
                            }
                            if (id === 1) {
                                if (service['@Selected'] === "true" ) {
                                    expandKafkaService = true
                                }
                            }
                            if (id === 2) {
                                if (service['@Selected'] === "true") {
                                    expandFlinkService = true
                                }
                            }
                            if (id === 3) {
                                if (service['@Selected'] === "true" ) {
                                    expandStormService = true
                                }
                            }
                        })
                    }
                    break;
                case "Analytics":
                    if (Array.isArray(val.Service)) {
                        val.Service.filter((service, id) => {
                            if (id === 0) {
                                if (service['@Selected'] === "true") {
                                    expandYarnService = true
                                }
                            }
                            if (id === 1) {
                                if (service['@Selected'] === "true") {
                                    expandAnalyticsSparkService = true
                                }
                            }
                        })
                    }
                    break;
                case "AI":
                    if (Array.isArray(val.Service)) {
                        val.Service.filter((service, id) => {
                            if (id === 0) {
                                if (service['@Selected'] === "true") {
                                    expandTensorflowService = true
                                }
                            }
                            if (id === 1) {
                                if (service['@Selected'] === "true" ) {
                                    expandPyTorchService = true
                                }
                            }
                        })
                    }
                    break;
                case "IoT":
                    if (Array.isArray(val.Service)) {
                        val.Service.filter((service, id) => {
                            if (id === 0) {
                                if (service['@Selected'] === "true") {
                                    expandMiNifiService = true
                                }
                            }
                        })
                    } else {
                        if (val.Service['@Selected'] === "true") {
                            expandMiNifiService = true
                        }
                    }
                    break;

            }

        })
    

        var temp = this.getActive();
        //let a=JSON.parse(this.props. workload.UserInputs.Environments.Functions.Function[0].Service[0]['@Selected'])
        return (
            <Article id="scroll" full={true} margin="none" pad={{ between: 'small' }} style={{ maxHeight: '95%' }} justify='between' >
                <Box>
                    <Tabs justify='start' activeIndex={this.state.activeIndex} onActive={(e) => {
                        this.setState(
                            {
                                activeIndex: e
                            }); this.props.defaultSizerWorkload.Indexes.functions = e;
                            //this.props.SelectedService.value="Tabchanged"
                    } }>

                        <Tab title="Storage">
                            <Box margin='small' pad={{ between: 'small' }}>
                                {LoadindData}
                                <Accordion title={Constants.DATA_LAKE}  expanded={expandHDFSService} isDefault={true} type='Storage' servers={serverList.storage} />
                                {/* <Accordion title='HDFS-EC' expanded = {false} isDefault={false} type='fs' servers={serverList.storage}/>
                   <Accordion  title='MapR and MapR-EC' expanded = {false} isDefault={false} type='Storage' servers={serverList.storage}/>*/}
                                <Accordion title='Scality' expanded={expandScalityService} isDefault={false} type='Storage' servers={serverList.storage} />
                                <Accordion title='Weka' expanded={expandWekaService} isDefault={false} type='Storage' servers={serverList.storage} />

                                {/*  <Accordion title='Kudu' expanded = {false} isDefault={false} type='fs' servers={serverList.storage}/>
                    <Accordion title='Alluxio' expanded = {false} isDefault={false} type='fs' servers={serverList.storage}/>
                    <Accordion title='Ceph' expanded = {false} isDefault={false} type='fs' servers={serverList.storage}/> */}
                            </Box>
                        </Tab>
                        <Tab title="Database">
                            {temp}
                        </Tab>

                        <Tab title="Streaming">
                            <Box margin='small' pad={{ between: 'small' }}>
                                <Accordion title='Spark Streaming' type='Streaming' expanded={expandSparkService} isDefault={true} servers={serverList.streaming} />
                                <Accordion title='Kafka' type='Streaming' expanded={expandKafkaService} isDefault={false} servers={serverList.streaming} />
                                <Accordion title='Flink' type='Streaming' expanded={expandFlinkService} isDefault={false} servers={serverList.streaming} />
                                <Accordion title='Storm' type='Streaming' expanded={expandStormService} isDefault={false} servers={serverList.streaming} />
                            </Box>
                        </Tab>
                        <Tab title="Analytics">
                            <Box margin='small' pad={{ between: 'small' }}>
                                <Accordion title='Yarn' expanded={expandYarnService} isDefault={true} type='Analytics' />
                                <Accordion title='Spark' expanded={expandAnalyticsSparkService} isDefault={false} type='Analytics' />
                                {/* <Accordion title='Flink' expanded = {false} isDefault={false} type='Analytics'/> 
                     <Accordion title='Storm' expanded = {false} isDefault={false} type='Analytics'/>*/}
                            </Box>
                        </Tab>
                        <Tab title="AI">
                            <Box margin='small' pad={{ between: 'small' }}>
                                <Accordion title='Tensorflow' type='AI' expanded={expandTensorflowService} isDefault={false} />
                                <Accordion title='PyTorch' type='AI' expanded={expandPyTorchService} isDefault={false} />
                                {/*<Accordion title='H2O' type='AI'expanded = {false} isDefault={false}/>     
                    <Accordion title='SparkML'type="AI" expanded = {false} isDefault={false}/>*/}
                            </Box>
                        </Tab>
                        <Tab title="IoT">
                            <Box margin='small' pad={{ between: 'small' }}>
                                <Accordion title="MiNifi" type="IoT" expanded={expandMiNifiService} isDefault={false} />
                                {/* <Accordion title='PXI' type="IoT" expanded = {false} isDefault={false}/>  */}
                            </Box>
                        </Tab>
                    </Tabs>
                </Box>

            </Article>
        );
    }
}
const mapStateToProps = (state) => {
    return {

        isLoading: state.sizerWorkload.isLoading,
        workload: state.sizerWorkload.workload,
        activeSession: state.sessions.activeSession,
        defaultSizerWorkload: state.sizerWorkload,
        iterationvalue:state.sizerWorkload.iterationCount,
        country: state.sessions.Country, // Selected country is not updated in the workload. - By Aditya
        sessionsDefaults: state.sessions.sessionDefaults
       // SelectedService:state.sizerWorkload.title,
         //SelectedService:state.sessions.activeSession.title,
        
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        // OnFetchDefaults:()=>{
        //     dispatch(fetchDefaults());
        //   },
        OnToggleSizeButton: (value) => { dispatch(toggleSizeButton(value)) },
        OnDefaultFetchServerList: (value) => {
            dispatch(defaultfetchServerList(value));
        },
        OnIterationCountIncrease:(value)=>{
            dispatch({type:'ITERATION_INCREASE',payload:value})
        },         
        onUpdateDefaultSession: (inputs) => {
            dispatch({ type: 'UPDATE_SESSION_DEFAULTS', payload: inputs })
        },
        GetExtraNodesQty: (value) => {
            dispatch(getextranodesqty(value));
          },
        // SelectedServericeValue:(value)=>{
        //     dispatch({type:'SELECTED_SERVICE_VALUE',payload:value})
        // }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Functions);



// WEBPACK FOOTER //
// ./src/SizerUI/SizerScreens/Functions.js